module.exports = __webpack_public_path__ + "static/media/natalie-portman-win.0d1022c7.jpg";